import api from './api'
import type { AppNotification } from '@/types'

export const notificationsService = {
  async list(skip = 0, take = 30) {
    const { data } = await api.get('/notifications', { params: { skip, take } })
    return data.data as { notifications: AppNotification[]; total: number }
  },

  async getUnreadCount() {
    const { data } = await api.get('/notifications/unread-count')
    return data.data.unreadCount as number
  },

  async markAsRead(id: string) {
    const { data } = await api.put(`/notifications/${id}/read`)
    return data.data
  },

  async markAllAsRead() {
    const { data } = await api.post('/notifications/read-all')
    return data.data
  },

  async dismiss(id: string) {
    const { data } = await api.put(`/notifications/${id}/dismiss`)
    return data.data
  },
}
